/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import3 from '../../ui-elements/icon/icon.component';
import * as import4 from './order-summary-icon.component';
import * as import5 from '../order.model';
const styles_OrderSummaryIconComponent:any[] = ([] as any[]);
export const RenderType_OrderSummaryIconComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderSummaryIconComponent,
  data: {}
}
);
function View_OrderSummaryIconComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-summary'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.orderSummary($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['highlighted']),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'order-summary-icon'
      ]
    ],(null as any),(null as any),(null as any),import2.View_IconComponent_0,import2.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import3.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'order-summary-count'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'order-summary';
    const currVal_1:any = ck(v,2,0,co.highlighted);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = 'shopping-cart';
    ck(v,5,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.itemCount;
    ck(v,8,0,currVal_3);
  });
}
export function View_OrderSummaryIconComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderSummaryIconComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.OrderSummaryIconComponent = v.component;
    const currVal_0:any = co.orderModel.orderStarted;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderSummaryIconComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),View_OrderSummaryIconComponent_0,RenderType_OrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import4.OrderSummaryIconComponent,[
      import5.OrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderSummaryIconComponentNgFactory:import0.ComponentFactory<import4.OrderSummaryIconComponent> = import0.ɵccf('woa-order-summary-icon',import4.OrderSummaryIconComponent,View_OrderSummaryIconComponent_Host_0,{},{onOrderSummary: 'onOrderSummary'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItc3VtbWFyeS1pY29uL29yZGVyLXN1bW1hcnktaWNvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9vcmRlci9vcmRlci1zdW1tYXJ5LWljb24vb3JkZXItc3VtbWFyeS1pY29uLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItc3VtbWFyeS1pY29uL29yZGVyLXN1bW1hcnktaWNvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItc3VtbWFyeS1pY29uL29yZGVyLXN1bW1hcnktaWNvbi5jb21wb25lbnQudHMuT3JkZXJTdW1tYXJ5SWNvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgKm5nSWY9XCJvcmRlck1vZGVsLm9yZGVyU3RhcnRlZFwiXG4gICAgIGNsYXNzPVwib3JkZXItc3VtbWFyeVwiIFtuZ0NsYXNzXT1cInsnaGlnaGxpZ2h0ZWQnOiBoaWdobGlnaHRlZH1cIiAoY2xpY2spPVwib3JkZXJTdW1tYXJ5KCRldmVudClcIj5cbiAgICA8d29hLWljb24gY2xhc3M9XCJvcmRlci1zdW1tYXJ5LWljb25cIiBbbmFtZV09XCInc2hvcHBpbmctY2FydCdcIj48L3dvYS1pY29uPlxuICAgIDxzcGFuIGNsYXNzPVwib3JkZXItc3VtbWFyeS1jb3VudFwiPlxuICAgICAgICB7e2l0ZW1Db3VudH19XG4gICAgPC9zcGFuPlxuPC9kaXY+XG4iLCI8d29hLW9yZGVyLXN1bW1hcnktaWNvbj48L3dvYS1vcmRlci1zdW1tYXJ5LWljb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQ29FO1FBQUE7UUFBQTtNQUFBO01BRHBFO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQzJCO0lBQXdFO01BQy9GO1FBQUE7UUFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5RTtNQUN6RTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWtDO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFM0I7Ozs7SUFKTjtJQUFzQjtJQUQzQixTQUNLLFVBQXNCLFNBRDNCO0lBRXlDO0lBQXJDLFNBQXFDLFNBQXJDOzs7SUFDa0M7SUFBQTs7Ozs7SUFIdEM7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQU1NOzs7O0lBTkQ7SUFBTCxTQUFLLFNBQUw7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/order/order-summary-icon/order-summary-icon.component.ngfactory.ts